// data keys stored in the local storage
export const LOCAL_STORAGE = {
    // Reducer userProfile
    USER_PROFILE: 'userProfile',
    // Reducer keys
    CURRENT_LANGUAGE: 'currentLang',
} as const;

export const { USER_PROFILE, CURRENT_LANGUAGE } = LOCAL_STORAGE;
